import { render, staticRenderFns } from "./LancamentoDeFrequenciaPage.vue?vue&type=template&id=7adccbbe&scoped=true"
import script from "./LancamentoDeFrequenciaPage.vue?vue&type=script&lang=js"
export * from "./LancamentoDeFrequenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adccbbe",
  null
  
)

export default component.exports